import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";

export const useViewActivityQuery = (options = {}) => {
  const { enabled = true, params = {} } = options;

  return useQuery({
    queryKey: ["viewActivityLog", params],
    queryFn: async () => {
      const res = await api.get("/activity-log/show", { params });
      return res.data;
    },
    enabled,
  });
};
